import ContentPage from "../../Content";

function ApproCommercialPage(){
    return (
        <>
            <ContentPage>
                
            </ContentPage>
        </>
    )
}

export default ApproCommercialPage;